import React from 'react';
import { Section } from './ui/Section';
import { Star, CheckCircle } from 'lucide-react';
const testimonials = [{
  name: 'Robert M.',
  location: 'Texas, USA',
  rating: 5,
  title: 'Finally sleeping through the night!',
  content: "I used to wake up 4-5 times a night. After just two weeks of ProstaVive, I'm down to maybe once, sometimes not at all. I feel so much more rested and energetic during the day.",
  verified: true
}, {
  name: 'James D.',
  location: 'Florida, USA',
  rating: 5,
  title: 'Incredible difference in flow',
  content: 'The hesitation is gone. The flow is strong again. I feel like I did 20 years ago. My wife has noticed the difference in my mood too. Highly recommended!',
  verified: true
}, {
  name: 'William T.',
  location: 'Ohio, USA',
  rating: 5,
  title: "Best supplement I've tried",
  content: "I've tried saw palmetto and other supplements before with little success. ProstaVive is different. The powder mix is easy to take and actually tastes good. Results speak for themselves.",
  verified: true
}];
export function TestimonialsSection() {
  return <Section background="light" data-id="element-269">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-270">
        <h2 className="text-3xl md:text-5xl font-bold text-[#0B1C3E] mb-6" data-id="element-271">
          Real Results From Real Men
        </h2>
        <p className="text-xl text-gray-600" data-id="element-272">
          Join thousands of satisfied customers who have taken back control of
          their health.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-273">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col" data-id="element-274">
            <div className="flex items-center gap-1 mb-4" data-id="element-275">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#FFC107] fill-current" data-id="element-276" />)}
            </div>
            <h3 className="text-xl font-bold text-[#0B1C3E] mb-3" data-id="element-277">{t.title}</h3>
            <p className="text-gray-600 mb-6 flex-grow italic" data-id="element-278">"{t.content}"</p>
            <div className="flex items-center gap-3 mt-auto pt-6 border-t border-gray-100" data-id="element-279">
              <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center font-bold text-gray-500" data-id="element-280">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-281">
                <div className="font-bold text-[#0B1C3E]" data-id="element-282">{t.name}</div>
                <div className="text-sm text-gray-500" data-id="element-283">{t.location}</div>
              </div>
              {t.verified && <div className="ml-auto flex items-center gap-1 text-green-600 text-xs font-medium bg-green-50 px-2 py-1 rounded-full" data-id="element-284">
                  <CheckCircle className="w-3 h-3" data-id="element-285" />
                  Verified
                </div>}
            </div>
          </div>)}
      </div>
    </Section>;
}